import {BaseTsfrValidator} from './validator';

export {TsfrDirective} from './directive';
export {TsfrPipe} from './pipe';

export const TSFR_VALIDATORS = [BaseTsfrValidator];
